export const productDraft = (product) => ({
  name: { en: '', ar: '', ...product.name },
  category: { en: '', ar: '', ...product.category },
  description: { en: '', ar: '', ...product.description },
  price_min: String(product.price_min ?? ''),
  price_max: product.price_max == null ? '' : String(product.price_max),
  currency: product.currency || 'BHD',
  stock_quantity: String(product.stock_quantity ?? 0),
  is_active: product.is_active !== false,
  image_url: product.image_url || '',
  images: [...(product.images || [])],
  specs: (product.specs || []).map(spec => ({ en: '', ar: '', ...spec })),
});

export const changedProductFields = (original, draft) => Object.fromEntries(
  Object.keys(draft).filter(key => JSON.stringify(original[key]) !== JSON.stringify(draft[key]))
    .map(key => [key, draft[key]])
);

export const validateProductDraft = (draft) => {
  const errors = [];
  if (!draft.name.en.trim() && !draft.name.ar.trim()) errors.push('Enter a name in at least one language.');
  const minimum = Number(draft.price_min);
  const maximum = draft.price_max.trim() === '' ? null : Number(draft.price_max);
  if (!draft.price_min.trim() || !Number.isFinite(minimum) || minimum < 0) errors.push('Minimum price must be a non-negative number.');
  if (maximum !== null && (!Number.isFinite(maximum) || maximum < 0 || maximum < minimum)) errors.push('Maximum price must be at least the minimum price, or blank.');
  const stock = Number(draft.stock_quantity);
  if (!draft.stock_quantity.trim() || !Number.isSafeInteger(stock) || stock < 0) errors.push('Stock must be a non-negative whole number.');
  if (!/^[A-Z]{3}$/.test(draft.currency)) errors.push('Use a three-letter currency code, such as BHD.');
  if ([draft.image_url, ...draft.images].some(url => url && !/^(https?:\/\/|\/(?!\/))/.test(url))) errors.push('Image URLs must start with http://, https://, or /.');
  return errors;
};

export const productPatch = (entry) => {
  const changes = changedProductFields(productDraft(entry.original), entry.value);
  for (const field of ['price_min', 'price_max', 'stock_quantity']) {
    if (field in changes) changes[field] = field === 'price_max' && changes[field].trim() === '' ? null : Number(changes[field]);
  }
  if (changes.images) changes.images = [...new Set(changes.images.map(url => url.trim()).filter(Boolean))];
  return { id: entry.original.id, expected_updated_at: entry.original.updated_at, changes };
};
